var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[(_vm.show)?_c('menuPage',{staticClass:"menuPage"}):_vm._e(),_c('div',{staticClass:"content"},[(_vm.show)?_c('contHeader',{staticClass:"contHeader"}):_vm._e(),_c('router-view',{staticClass:"view",attrs:{"element-loading-spinner":"el-icon-loading"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }